import LegalPage from "@/components/site/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms & Conditions"
      intro="These Terms & Conditions govern your use of the services provided by Contentium Tech, including its educational initiative Eduzy."
      downloadUrl="https://www.contentiumtech.com/Contentium_Tech_Terms_and_Conditions_v1.0.pdf"
      sections={[
        {
          id: "acceptance",
          heading: "Acceptance of Terms",
          body: [
            "These Terms & Conditions govern your use of the services provided by Contentium Tech, including its educational initiative Eduzy. By accessing or using our website, platforms, or services, you agree to comply with these terms and all applicable laws and regulations.",
            "Contentium Tech provides technology-enabled content and learning support designed to make education accessible and scalable. While we strive to deliver high-quality and structured content, we do not guarantee specific academic results or outcomes, as these depend on individual effort and external factors.",
          ],
        },
        {
          id: "user-responsibilities",
          heading: "User Responsibilities",
          body: [
            "Users are responsible for providing accurate information and for using the platform appropriately. Any misuse, unauthorized access, or attempt to disrupt services may result in suspension or termination of access without prior notice.",
            "For users under the age of 18, access to services must be supervised or authorized by a parent or legal guardian. Parents are responsible for monitoring their child's interaction with the platform and ensuring appropriate use of content and data.",
          ],
        },
        {
          id: "intellectual-property",
          heading: "Intellectual Property",
          body: [
            "All content, materials, and intellectual property available through Contentium Tech remain the property of the company unless otherwise stated. Unauthorized reproduction, distribution, or misuse of content is strictly prohibited.",
          ],
        },
        {
          id: "liability",
          heading: "Limitation of Liability",
          body: [
            "Contentium Tech shall not be held liable for any indirect, incidental, or consequential damages arising from the use of its services, including but not limited to loss of data, academic outcomes, or service interruptions.",
          ],
        },
        {
          id: "changes",
          heading: "Changes to Terms",
          body: [
            "These terms may be updated periodically to reflect changes in services, technology, or legal requirements. Continued use of the platform constitutes acceptance of the updated terms.",
            "By using our services, you acknowledge that you have read, understood, and agreed to these Terms & Conditions.",
          ],
        },
      ]}
    />
  );
}
